import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        filter: '=',
        classifiers: '<',
        filterOverview: '=',
        defaultFilter: '=',
        sites: '<',
        licences: '<'
    },
    template: `
    <div class="block02" ng-class="{ open: vm.filters === true }" ng-if="vm.view !== 'modal'">
        <div class="heading01 theme01">
            <h3 ng-click="vm.changeFilter()">{{ 'filter.Filters' | translate }}</h3>
        </div>
        <div class="table-filters" ng-if="vm.filters === true">
            <form class="form form-filter type02" ng-submit="vm.applyFilter()">
                <div class="fields">
                    <div class="row row-md separated">
                        <label class="label">{{ 'filter.Licence name' | translate }}</label>
                        <div class="items">
                            <div
                                ng-dropdown-multiselect=""
                                options="vm.multiFilter.licences.options"
                                selected-model="vm.multiFilter.licences.model"
                                events="vm.multiFilter.licences.events"
                                extra-settings="vm.multiFilter.licences.settings"
                                translation-texts="vm.filterTranslations">
                            </div>
                        </div>
                    </div>
                    <div class="row row-md separated">
                        <label class="label">{{ 'filter.Licence status' | translate }}</label>
                        <div class="items">
                            <div
                                ng-dropdown-multiselect=""
                                options="vm.multiFilter.statuses.options"
                                selected-model="vm.multiFilter.statuses.model"
                                extra-settings="vm.multiFilter.statuses.settings"
                                translation-texts="vm.filterTranslations">
                            </div>
                        </div>
                    </div>
                     <div class="row row-md separated">
                        <label class="label">{{ 'filter.Licence period' | translate }}</label>
                        <div class="items">
                            <div
                                ng-dropdown-multiselect=""
                                options="vm.multiFilter.licencePeriods.options"
                                selected-model="vm.multiFilter.licencePeriods.model"
                                extra-settings="vm.multiFilter.licencePeriods.settings"
                                translation-texts="vm.filterTranslations">
                            </div>
                        </div>
                    </div>
                    <div class="row row-md separated">
                        <label class="label">{{ 'filter.Licence period status' | translate }}</label>
                        <div class="items">
                            <div
                                ng-dropdown-multiselect=""
                                options="vm.multiFilter.periodStatuses.options"
                                selected-model="vm.multiFilter.periodStatuses.model"
                                extra-settings="vm.multiFilter.periodStatuses.settings"
                                translation-texts="vm.filterTranslations">
                            </div>
                        </div>
                    </div>
                    <div class="row row-md">
                        <label class="label">{{ 'filter.Employee' | translate }}</label>
                        <div class="items">
                            <autocomplete
                                label-attribute="'displayName'"
                                selected-item="vm.selectedEmployee"
                                ng-model="vm.filter.userId"
                                value-attribute="'id'"
                                placeholder="vm.$translate.instant('filter.Find an employee')"
                                query="vm.queryEmployees(input)"
                            />
                        </div>
                    </div>
                    <div class="row row-md separated">
                        <label class="label">{{ 'filter.Site' | translate }}</label>
                        <div class="items">
                            <div
                                ng-dropdown-multiselect=""
                                options="vm.multiFilter.sites.options"
                                selected-model="vm.multiFilter.sites.model"
                                extra-settings="vm.multiFilter.sites.settings"
                                translation-texts="vm.filterTranslations"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'filter.Department' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.departmentId"
                                ng-options="item.id as item.value for item in vm.departments">
                            <option value=""></option>
                        </select>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'filter.Role' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.roleId"
                                ng-options="item.id as item.value for item in vm.roles">
                            <option value=""></option>
                        </select>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'filter.Level' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.levelId"
                                ng-options="item.id as item.value for item in vm.levels">
                            <option value=""></option>
                        </select>
                        </div>
                    </div>
                    <div class="row row-md">
                        <label class="label">{{ 'filter.Direct manager' | translate }}</label>
                        <div class="items">
                            <autocomplete
                                label-attribute="'displayName'"
                                selected-item="vm.selectedManager"
                                ng-model="vm.filter.directManagerId"
                                value-attribute="'id'"
                                placeholder="vm.$translate.instant('filter.Find a manager')"
                                query="vm.queryManagers(input)"
                            />
                        </div>
                    </div>
                </div>
                <ul class="actions01">
                    <li><input type="button" ng-click="vm.resetFilter()" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                    <li><input type="submit" class="btn main" value="{{ 'filter.Generate report' | translate }}"></li>
                </ul>
            </form>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, ROLE_CODE_ENUM, CLASSIFIER_ENUM, USER_LICENCE_STATUS_ENUM, USER_LICENCE_PERIOD_STATUS_ENUM,
                 UserResource, MomentService, LicenceService, StringService, FilterService, $window) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.USER_LICENCE_STATUS_ENUM = USER_LICENCE_STATUS_ENUM;
        this.USER_LICENCE_PERIOD_STATUS_ENUM = USER_LICENCE_PERIOD_STATUS_ENUM;
        this.UserResource = UserResource;
        this.MomentService = MomentService;
        this.LicenceService = LicenceService;
        this.StringService = StringService;
        this.FilterService = FilterService;
        this.$window = $window;
    }

    $onInit () {
        this.departments = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.LEVEL);

        // note the string object keys which represent multi-filter fields
        this.filterOverview = {
            labels: {
                licenceIds: this.$translate.instant('filter.Licence name'),
                statuses: this.$translate.instant('filter.Licence statuses'),
                siteIds: this.$translate.instant('filter.Site'),
                userId: this.$translate.instant('filter.Employee'),
                departmentId: this.$translate.instant('filter.Department'),
                roleId: this.$translate.instant('filter.Role'),
                levelId: this.$translate.instant('filter.Level'),
                directManagerId: this.$translate.instant('filter.Direct manager'),
                periodIds: this.$translate.instant('filter.Licence period'),
                periodStatuses: this.$translate.instant('filter.Licence period status')
            },
            values: {}
        };

        this.initMultiFilter();
        this.updateFilterOverview();
        this.filterTranslations = this.FilterService.getTranslations();

        this.filters = JSON.parse(this.$window.localStorage.getItem('is_licence_report_filter_opened'));
    }

    changeFilter () {
        this.filters = !this.filters;
        this.$window.localStorage.setItem('is_licence_report_filter_opened', this.filters);
    }

    initMultiFilter () {
        const licenceOptions = this.licences.map(licence => {
            return {
                value: licence.id,
                label: licence.name
            };
        });

        const siteOptions = this.sites.map(site => {
            return {
                value: site.id,
                label: site.name
            };
        });

        const statusOptions = [
            { value: this.USER_LICENCE_STATUS_ENUM.KEYS.ACQUIRED, label: this.USER_LICENCE_STATUS_ENUM.LABELS.ACQUIRED },
            { value: this.USER_LICENCE_STATUS_ENUM.KEYS.NOT_ACQUIRED, label: this.USER_LICENCE_STATUS_ENUM.LABELS.NOT_ACQUIRED }
        ];

        const licencePeriodOptions = this.LicenceService.getLicencePeriodMultiselectOptions(this.licences);

        const periodStatusOptions = [
            { value: this.USER_LICENCE_PERIOD_STATUS_ENUM.KEYS.ACQUIRED, label: this.USER_LICENCE_PERIOD_STATUS_ENUM.LABELS.ACQUIRED },
            { value: this.USER_LICENCE_PERIOD_STATUS_ENUM.KEYS.NOT_ACQUIRED, label: this.USER_LICENCE_PERIOD_STATUS_ENUM.LABELS.NOT_ACQUIRED }
        ];

        this.multiFilter = {
            licences: {
                model: this.lodash.clone(licenceOptions),
                options: licenceOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                },
                events: {
                    onSelectionChanged: () => {
                        const selectedLicenceIds = this.multiFilter.licences.model.map(item => item.value);
                        this.multiFilter.licencePeriods.options = this.LicenceService.getLicencePeriodMultiselectOptions(
                            this.licences.filter((licence) => selectedLicenceIds.indexOf(licence.id) >= 0)
                        );

                        // all new options will be auto selected automatically
                        this.multiFilter.licencePeriods.model = this.lodash.clone(this.multiFilter.licencePeriods.options);
                    }
                }
            },
            statuses: {
                model: this.lodash.clone(statusOptions),
                options: statusOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            },
            licencePeriods: {
                model: this.lodash.clone(licencePeriodOptions),
                options: licencePeriodOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    },
                    groupByTextProvider: (groupValue) => groupValue,
                    groupBy: 'licenceName'
                }
            },
            periodStatuses: {
                model: this.lodash.clone(periodStatusOptions),
                options: periodStatusOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            },
            sites: {
                model: this.lodash.clone(siteOptions),
                options: siteOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            }
        };
        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    queryEmployees (input) {
        const params = {
            roleCode: this.ROLE_CODE_ENUM.KEYS.EMPLOYEE,
            name: input,
            pageSize: 0
        };
        const siteIds = this.multiFilter.sites.model.map(site => site.value);
        if (siteIds) {
            params['siteIds[]'] = siteIds;
        }
        return this.UserResource.query(params).$promise;
    }

    queryManagers (input) {
        const params = {
            roleCode: this.ROLE_CODE_ENUM.KEYS.DIRECT_MANAGER,
            name: input,
            pageSize: 0
        };
        const siteIds = this.multiFilter.sites.model.map(site => site.value);
        if (siteIds) {
            params['siteIds[]'] = siteIds;
        }
        return this.UserResource.query(params).$promise;
    }

    applyFilter () {
        const licenceIds = !this.multiFilter.licences.model.length ? [-1] : this.multiFilter.licences.model.map(licence => licence.value);
        const periodIds = !this.multiFilter.licencePeriods.model.length ? [-1] : this.multiFilter.licencePeriods.model.map(licence => licence.value);
        const statuses = !this.multiFilter.statuses.model.length ? [-1] : this.multiFilter.statuses.model.map(status => status.value);
        const periodStatuses = !this.multiFilter.periodStatuses.model.length ? [-1] : this.multiFilter.periodStatuses.model.map(status => status.value);
        const siteIds = !this.multiFilter.sites.model.length ? [-1] : this.multiFilter.sites.model.map(site => site.value);
        this.filter = this.lodash.assign(this.filter, { licenceIds });
        this.filter = this.lodash.assign(this.filter, { statuses });
        this.filter = this.lodash.assign(this.filter, { periodIds });
        this.filter = this.lodash.assign(this.filter, { periodStatuses });
        this.filter = this.lodash.assign(this.filter, { siteIds });
        this.list.fetch({}, this.filter).then(() => {
            this.updateFilterOverview();
        });
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.multiFilter = angular.copy(this.defaultMultiFilter);
        this.applyFilter();
        this.selectedEmployee = null;
        this.selectedManager = null;
    }

    updateFilterOverview () {
        if (!this.list.invalid) {
            // empty old values
            this.filterOverview.values = {};
            this.filterOverview.fullText = {};
            this.lodash.forEach(this.filter, (value, key) => {
                if (key === 'siteIds' && value[0] !== -1) {
                    const siteValues = value.map((siteId) => this.lodash.find(this.sites, { id: siteId }).name).join('; ');
                    this.filterOverview.values[key] = this.StringService.cutStringAndAppendEnding(siteValues);
                    this.filterOverview.fullText[key] = siteValues;
                }
                else if (key === 'licenceIds' && value[0] !== -1) {
                    const licencesString = value.map((licenceId) => this.lodash.find(this.licences, { id: licenceId }).name).join('; ');
                    this.filterOverview.values[key] = this.StringService.cutStringAndAppendEnding(licencesString);
                    this.filterOverview.fullText[key] = licencesString;
                }
                else if (key === 'statuses' && value[0] !== -1) {
                    this.filterOverview.values[key] = value.map((status) => this.USER_LICENCE_STATUS_ENUM.LABELS[status]).join('; ');
                }
                else if (key === 'userId' && value) {
                    this.filterOverview.values[key] = this.selectedEmployee.displayName;
                }
                else if (key === 'directManagerId' && value) {
                    this.filterOverview.values[key] = this.selectedManager.displayName;
                }
                else if (key === 'departmentId') {
                    this.filterOverview.values[key] = (this.lodash.find(this.departments, { id: value }) || {}).value;
                }
                else if (key === 'roleId') {
                    this.filterOverview.values[key] = (this.lodash.find(this.roles, { id: value }) || {}).value;
                }
                else if (key === 'levelId') {
                    this.filterOverview.values[key] = (this.lodash.find(this.levels, { id: value }) || {}).value;
                }
                else if (key === 'periodIds') {
                    const periodString = value.map((licencePeriodId) => this.LicenceService.getLicencePeriodOverviewText(this.licences, licencePeriodId)).join('; ');
                    this.filterOverview.values[key] = periodString.length > 145 ? `${periodString.substring(0, 145)}...` : periodString;
                    this.filterOverview.fullText[key] = periodString;
                }
                else if (key === 'periodStatuses' && value[0] !== -1) {
                    this.filterOverview.values[key] = value.map((status) => this.USER_LICENCE_PERIOD_STATUS_ENUM.LABELS[status]).join('; ');
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/licencereport/filter/index.js